import styled from "styled-components";

const BLUE = "#008cff";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 410;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const Sheet = styled.div`
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  max-height: min(88vh, 560px);
  animation: dl-sheet-up 0.25s ease-out;

  @keyframes dl-sheet-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const SheetHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 16px;
  border-bottom: 1px solid #d8d8d8;
  flex-shrink: 0;
`;

export const CloseBtn = styled.button`
  border: none;
  background: transparent;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #757575;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
`;

export const SheetTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  text-align: left;
  line-height: 1;
  flex: 1;
`;

export const Body = styled.div`
  padding: 24px 16px 32px;
  flex: 1;
  overflow-y: auto;
`;

export const Description = styled.div`
  margin: 0 0 24px;
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 20px;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RadioRow = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 10px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;

  &:focus-visible {
    outline: 2px solid ${BLUE};
    outline-offset: 2px;
    border-radius: 8px;
  }
`;

export const RadioOuter = styled.span<{ $selected?: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${(p) => (p.$selected ? BLUE : "#d1d5db")};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

export const RadioInner = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${BLUE};
`;

export const RadioLabel = styled.span<{ $selected?: boolean }>`
  font-size: 16px;
  font-weight: ${(p) => (p.$selected ? 900 : 400)};
  color: #4a4a4a;
  line-height: 1.3;
`;

export const Footer = styled.div`
  padding: 12px 16px;
  padding-bottom: max(32px, env(safe-area-inset-bottom, 0px));
  width: 100%;
  box-sizing: border-box;
`;
